import { CancelProductRequest } from '../../models/ss-api/requests/cancel.product.request';
import { BaseResponse } from '../../models/comm-http/responses/BaseResponse';
import { ssApiService } from '../../services/ss-api.service';
import { Component, OnInit } from '@angular/core';

import Swal, { SweetAlertIcon } from 'sweetalert2';
import { xToastr, ToastrTypes } from 'app/shared/Toastr';
import { DashboardLicenseResponse } from '../../models/ss-api/responses/dashboard.license.response';
import { GlobalServices } from '../../services/global.service';
import * as moment from 'moment';
import { HttpError } from 'app/models/errors/HttpError';
import { ResumeLicenseSimulationResponse } from '../../models/ss-api/responses/resume.license..simulation.response';
import { ResumeLicenseSimulationRequest } from '../../models/ss-api/requests/resume.license.simulation.request';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';

export interface IConfirmDialogModel {
	title: string;
	subTitle: string;
	message: string;
	License: DashboardLicenseResponse;

}

export enum CancelDialogTypes {
	standard = 0,
	isHoldScheduled = 1,
	isOnHold = 2,
}

@Component({
	selector: 'cancellation-request-dialog',
	styleUrls: ['./cancellation-request-dialog.component.scss'],
	templateUrl: './cancellation-request-dialog.component.html'
})
export class CancellationRequestDialogComponent implements IConfirmDialogModel, OnInit {

	isBusy = false;

  confirmTitle: string = 'Cancel License Key';
  confirmMessage: string = 'You are about to cancel this License Key.';

	successTitle: string = 'Cancellation successfull';
	successMessage: string = 'Your license has been cancelled.';

	errorTitle: string = 'Error';
	errorMessage: string = 'We were not able to cancel your license. Please contact support.';

  cancelledTitle: string = 'Cancel License Key Dismissed';
	cancelledMessage: string = 'Your request has been dismissed.';


	title: string;
	subTitle: string;
	message: string;
	License: DashboardLicenseResponse;
	isSecondStyle: boolean;

	cancelDialogType: CancelDialogTypes = CancelDialogTypes.standard;

	CancellationDate: Date;

	CancellationReason: string;
	CancellationComment: string;

	step: number = 1;

	ResumeSimulationResponse: ResumeLicenseSimulationResponse;

    result: any;

	constructor(
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
		private api: ssApiService,
		private gb: GlobalServices
	) {
	}

	
	ngOnInit() {
        this.title = this.config.data.title;
        this.subTitle = this.config.data.subTitle;
        this.message = this.config.data.message;
        this.License = this.config.data.License;
        this.isSecondStyle = this.config.data.isSecondStyle;

		this.CancellationDate = moment.utc(this.License.NextBillingDate).toDate();

		console.log('cancel dialog License: ', this.License);

		if( this.License.IsScheduledHold ) {
			this.cancelDialogType = CancelDialogTypes.isHoldScheduled;
			this.DoResumeLicenseSimulation();
		} else if( this.License.IsOnHold ) {
			this.cancelDialogType = CancelDialogTypes.isOnHold;
			this.DoResumeLicenseSimulation();
		}


	}

    close() {
        this.ref.close();
    }
	

	DoResumeLicenseSimulation() {

		this.isBusy = true;

		let request: ResumeLicenseSimulationRequest = {
			LicenseKey: this.License.Key,
			Initials: 'aa'
		};

		let disposable = this.api.ResumeLicenseSimulation(request).subscribe(response => {
			disposable.unsubscribe();

			console.log('ResumeLicenceSimulation : ', response);

			if (response.Result)
				this.ResumeSimulationResponse = response.Data;
			
			this.isBusy = false;
			
		});

	}


	private CancelProduct(): Promise<any> {

		// if (this.SelectedCreditCard == undefined)
		// we didn't change the credit card selection
		// this.SelectedCreditCard = this.CreditCards[0];

		let request = new CancelProductRequest();
		request.LicenseKey = this.License.Key;
		request.CancellationReason = this.CancellationReason;
		request.AdminID = this.gb.AdminID;
		request.CancellationComments = this.CancellationComment;

		return this.api.ProductCancel(request)
			.toPromise()
			.then(response => {

				if (!response.Result)
					return; // error

				this.result = response.Result;
				return response;
			},
				error => {
					this.result = false;
					console.log("Cancel Error Response:", error);
					return error;
				})
			.catch((error: HttpError) => {
				console.log("TryCatch error : ", error);
				this.result = false;
				return error;
			});

	}

	ProcessCancellation(): Promise<any> {
		// confirm
		return Swal.fire({
			title: this.confirmTitle,
			text: this.confirmMessage,
			icon: 'warning',
			showCancelButton: true,
			showCloseButton: true,
			confirmButtonText: 'Yes, cancel!',
			cancelButtonText: 'No, keep',
			allowOutsideClick: false,
			showLoaderOnConfirm: true,
			preConfirm: () => {
				// try to order
				return this.CancelProduct();
			}
		});

	}

	async confirm() {

		if (this.CancellationReason == '' || this.CancellationReason == undefined) {
			xToastr.ShowToast(ToastrTypes.Error, 'Error', 'Please enter \'Reason For Canceling\'');
			return;
		}

		await this.ProcessCancellation().then(
			(response: any) => {

				// init dialog vars
				let cType = 'success';
				let cTitle = this.successTitle;
				let cMessage = this.successMessage;


				if (response.isDismissed) {
					// show cancelled
					Swal.fire({
						title: this.cancelledTitle,
						text: this.cancelledMessage,
						icon: 'error',
						showCancelButton: false,
						showConfirmButton: false,
						timer: 1000
					})
					.then(() => { }, () => { }); // keep this line to prevent promise error;
				} else if (response.value && response.value.Result) {
					// show result
					Swal.fire(
						{

							title: cTitle,
							text: cMessage,
							icon: cType as SweetAlertIcon,
							showCancelButton: false,
							showConfirmButton: false,
							timer: 2000
						})
						.then(() => { }, () => { }); // keep this line to prevent promise error;
				}
				else {
					// not ok

					Swal.fire(
						{

							title: "Error Communicating with Server",
							text: "Please refresh page and try again, or contact our support team for assistance.",
							icon: 'error',
							showCancelButton: false,
							showConfirmButton: true,
							confirmButtonText: 'OK',
						})
						.then(() => { }, () => { }); // keep this line to prevent promise error;
				}




			},
			(dismiss) => {
				if (dismiss === 'cancel') {

					if (!confirm)
						return;

					// show cancelled
					Swal.fire({
						title: this.cancelledTitle,
						text: this.cancelledMessage,
						icon: 'error',
						showCancelButton: false,
						showConfirmButton: false,
						timer: 1000
					})
						.then(() => { }, () => { }); // keep this line to prevent promise error;
				}
			}
		);

		this.result = true;
		this.close();
	}


	cancel() {
		this.result = false;
		this.close();
	}

	nextStep() {
		this.step++;
	}

}
